<template>
  <div id="google-review" class="vs-con-loading__container">
    <h4 class="mb-6 text-2xl font-bold">Google Reply Review Setting</h4>

    <div class="flex align-center mt-base mb-6">
      <p class="mr-4 text-lg">Reply from: </p>
      <datepicker class="w-1/3 mr-3" :config="configdateTimePicker" v-model="replyFromDate" @input="changeDateValue"></datepicker>
        <!-- <vs-icon
          icon="backspace"
          size="medium"
          color="danger"
          class="cursor-pointer user-select-none mr-2"
        ></vs-icon> -->
       <vs-icon
          id="save-add--1"
          icon="check_circle"
          size="medium"
          color="primary"
          class="cursor-pointer user-select-none vs-con-loading__container save-add-animation"
          v-if="isDateChanged"
          @click.stop="saveDateFrom"
        ></vs-icon>
    </div>

    <div class="flex align-center">
      <vs-switch v-model="good_review" class="my-6" @click="updateGoodActive()" />
      <span class="pl-5 text-lg">Active auto reply for good review.</span>
    </div>

    <transition name="list">
      <div v-if="good_review">
        <div v-for="(review, index) in reviews.good_review.content" :key="index">
          <div class="flex align-center my-3">
            <!-- <input
              class="mr-3 p-3 w-full rounded-item review-input"
              type="text"
              :value="review.content"
              @input="changeGoodReview($event, index)"
              @change="changeGoodReview($event, index)"
              :class="{'border-new': review.status==3}"
            /> -->
            <textarea
              class="mb-0 mr-3 p-3 w-full rounded-item review-input"
              type="text"
              :id="`google-good-review-${index}`"
              :value="review.content"
              @input="changeGoodReview($event, index)"
              @change="changeGoodReview($event, index)"
              :class="{'border-new': review.status==3}"
            />
            <vs-icon
              :id="[`save-add-${index}`]"
              v-if="review.status != 1 && review.content != ''"
              icon="check_circle"
              size="medium"
              color="primary"
              class="cursor-pointer user-select-none vs-con-loading__container mr-2 save-add-animation"
              @click.stop="openLoadingContained(index, review), saveAdd('good', review, index)"
              :key="'a' + index"
            ></vs-icon>
            <vs-icon
              icon="remove_circle"
              size="medium"
              color="danger"
              class="cursor-pointer user-select-none"
              @click.stop="startRemoveGoodReview(review, index), updateActiveReview(review)"
            ></vs-icon>
          </div>
          <!-- <vs-icon icon="add_circle" size="medium" color="success" class="cursor-pointer user-select-none"
          v-if="index + 1 === reviews.good_review.content.length && reviews.good_review.content.length < 10" @click.stop="addGoodReview"></vs-icon>-->

          <vs-button
            type="filled"
            class="gradient gradient-primary no-shadow"
            color="primary"
            icon-pack="feather"
            icon="icon-plus"
            v-if="index + 1 === reviews.good_review.content.length && reviews.good_review.content.length < 10 && review.status != 3"
            @click.stop="addGoodReview"
          >Add</vs-button>

          <vs-popup class="holamundo delete-google-review-popup" title="Delete Good Review" :active.sync="popupGoodActive">
            <div class="text-center">
              <h3>Do you want to delete this review?</h3>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                <vs-button class="mr-6 align-center delete-responsive" @click="removeReview()">Delete</vs-button>
                <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupGoodActive=false">Cancel</vs-button>
              </div>
            </div>
          </vs-popup>
        </div>
        <!-- <vs-icon icon="add_circle" size="medium" color="success" class="cursor-pointer user-select-none"
        v-if="0 === reviews.good_review.content.length" @click.stop="addGoodReview"></vs-icon>-->
        <vs-button
          type="filled"
          class="gradient gradient-primary no-shadow"
          color="primary"
          icon-pack="feather"
          icon="icon-plus"
          v-if="0 === reviews.good_review.content.length"
          @click.stop="addGoodReview"
        >Add</vs-button>
      </div>
    </transition>

    <div class="flex align-center">
      <vs-switch v-model="bad_review" class="my-6" @click="updateBadActive()" />
      <span class="pl-5 text-lg">Active auto relpy for bad review.</span>
    </div>

    <transition name="list">
      <div v-if="bad_review">
        <div v-for="(review, index) in reviews.bad_review.content" :key="index">
          <div class="flex align-center my-3">
            <!-- <input
              class="mr-3 p-3 w-full rounded-item review-input"
              type="text"
              :value="review.content"
              @input="changeBadReview($event, index)"
              @change="changeBadReview($event, index)"
              :class="{'border-new': review.status==3}"
            /> -->
            <textarea
              class="mb-0 mr-3 p-3 w-full rounded-item review-input"
              type="text"
              :id="`google-bad-review-${index}`"
              :value="review.content"
              @input="changeBadReview($event, index)"
              @change="changeBadReview($event, index)"
              :class="{'border-new': review.status==3}"
            />
            <vs-icon
              :id="[`save-add-${index}`]"
              v-if="review.status != 1 && review.content != ''"
              icon="check_circle"
              size="medium"
              color="primary"
              class="cursor-pointer user-select-none vs-con-loading__container mr-2 save-add-animation"
              @click.stop="openLoadingContained(index, review), saveAdd('bad', review, index), updateActiveReview(review)"
              :key="'b' + index"
            ></vs-icon>
            <vs-icon
              icon="remove_circle"
              size="medium"
              color="danger"
              class="cursor-pointer user-select-none"
              @click.stop="startRemoveBadReview(review, index), updateActiveReview(review)"
            ></vs-icon>
          </div>
          <!-- <vs-icon icon="add_circle" size="medium" color="success" class="cursor-pointer user-select-none"
          v-if="index + 1 === reviews.bad_review.content.length && reviews.bad_review.content.length < 10" @click.stop="addBadReview"></vs-icon>-->

          <vs-button
            type="filled"
            class="gradient gradient-primary no-shadow"
            color="primary"
            icon-pack="feather"
            icon="icon-plus"
            v-if="index + 1 === reviews.bad_review.content.length && reviews.bad_review.content.length < 10 && review.status != 3"
            @click.stop="addBadReview"
          >Add</vs-button>

          <vs-popup class="holamundo delete-google-review-popup" title="Delete Bad Review" :active.sync="popupBadActive">
            <div class="text-center">
              <h3>Do you want to delete this review?</h3>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                <vs-button class="mr-6 align-center delete-responsive" @click="removeReview()">Delete</vs-button>
                <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupBadActive=false">Cancel</vs-button>
              </div>
            </div>
          </vs-popup>
        </div>
        <!-- <vs-icon icon="add_circle" size="medium" color="success" class="cursor-pointer user-select-none"
        v-if="0 === reviews.bad_review.content.length" @click.stop="addBadReview"></vs-icon>-->
        <vs-button
          type="filled"
          class="gradient gradient-primary no-shadow"
          color="primary"
          icon-pack="feather"
          icon="icon-plus"
          v-if="0 === reviews.bad_review.content.length"
          @click.stop="addBadReview"
        >Add</vs-button>
      </div>
    </transition>

    <!-- <vs-button class="mt-6" type="border" color="primary">Save</vs-button> -->
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
export default {
  name: "v-google-review",
  //   props: {
  //     dataChange: {
  //       type: Object
  //     }
  //   },
  components: {
    Datepicker
  },
  data() {
    let reviews = this.$store.getters["reviewList/googleReview"];
    let good_review = false;
    let bad_review = false;
    let activeReview = {};
    let loaded_data_num = 0;
    this.$store.dispatch("reviewList/GET_GOOGLE_REVIEW").then(() => {
      this.reviews = this.$store.getters["reviewList/googleReview"];
      this.updateActiveReview(
        this.$store.getters["reviewList/googleReview"].good_review.content[0]
      );
      this.good_review = this.$store.getters[
        "reviewList/googleReview"
      ].good_review.active;
      this.bad_review = this.$store.getters[
        "reviewList/googleReview"
      ].bad_review.active;

      this.setAutoHeightAllElem();

      this.loaded_data_num++;
    });
    return {
      good_review,
      bad_review,
      reviews,
      popupGoodActive: false,
      popupBadActive: false,
      activeReview,
      action_type: "",
      isOpenLoadingInDiv: false,
      isOpenLoadingInContained: false,
      loaded_data_num,
      replyFromDate: new Date(),
      configdateTimePicker: {
          enableTime: true,
          dateFormat: 'Y-m-d'
      },
      // disabledDates: {
      //   to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      // },
      isDateChanged: false
    };
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoadingInDiv = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoadingInDiv) {
          this.closeLoading();
          // this.$vs.notify({
          //   title: "Notification",
          //   text: this.action_type + " google review failed",
          //   color: "danger",
          //   position: "top-right"
          // });
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + " google review failed",
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
    },
    closeLoading(index) {
        this.isOpenLoadingInDiv = false;
      this.$vs.loading.close("#app > .con-vs-loading");
      if (index != undefined) {
        this.isOpenLoadingInContained = false;
        setTimeout(() => {
          this.$vs.loading.close(`#save-add-${index} > .con-vs-loading`);
        }, 700);
      }
    },
    changeDateValue() {
      this.isDateChanged = true;
    },
    saveDateFrom() {
      let obj = {
        key: 'config.google_auto_reply.reply_from',
        value: moment(this.replyFromDate).format('YYYY/MM/DD')
      }
      this.action_type = 'Save Reply From Date';
      this.openLoadingContained(-1);
      this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
          this.closeLoading(-1);
          this.$vs.notify({
            title: "Notification",
            text: this.action_type + " Success",
            color: "success",
            position: "top-right"
          });
          this.isDateChanged = false;
        }).catch(() => {
          this.closeLoading(-1);
          this.$vs.notify({
            title: "Notification",
            text: this.action_type + " Failed",
            color: "danger",
            position: "top-right"
          });
        });
    },
    updateGoodActive() {
      let data = {
        type: "good"
      };
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      if (this.good_review) {
        this.action_type = 'Inactive good';
        this.$store
          .dispatch("reviewList/INACTIVE_GOOGLE_REVIEW", data)
          .then(() => {
            this.getGoogleList();
          });
      } else {
        this.action_type = "Active good";
        this.$store
          .dispatch("reviewList/ACTIVE_GOOGLE_REVIEW", data)
          .then(() => {
            this.getGoogleList();
          });
      }
    },
    updateBadActive() {
      let data = {
        type: "bad"
      };
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      if (this.bad_review) {
        this.action_type = "Inactive bad";
        this.$store
          .dispatch("reviewList/INACTIVE_GOOGLE_REVIEW", data)
          .then(() => {
            this.getGoogleList();
          });
      } else {
        this.action_type = "Active bad";
        this.$store
          .dispatch("reviewList/ACTIVE_GOOGLE_REVIEW", data)
          .then(() => {
            this.getGoogleList();
          });
      }
    },
    getGoogleList() {
      this.$store.dispatch('reviewList/GET_GOOGLE_REVIEW').then(() => {
        this.setAutoHeightAllElem();
        this.closeLoading();
      });
    },
    updateActiveReview(review) {
      this.activeReview = review;
    },
    openLoadingContained(index) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: `#save-add-${index}`,
        type: "material",
        scale: 0.8
      });
      if (this.loadTime1) {
        clearTimeout(this.loadTime1);
        this.loadTime1 = null;
      }
      this.isOpenLoadingInContained = true;
      this.loadTime1 = setTimeout(() => {
        if (this.isOpenLoadingInContained) {
          this.closeLoading(index);
          // this.$vs.notify({
          //   title: "Notification",
          //   text: this.action_type + " google review failed",
          //   color: "danger",
          //   position: "top-right"
          // });
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + " google review failed",
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //     this.$vs.loading.close(`#save-add-${index} > .con-vs-loading`)
      // }, 1000);
    },
    saveAdd(type, review, index) {
      let data = {
        system: "google",
        type: type,
        content: review.content
      };
      // this.openLoadingInDiv();
      if (review.status == 2) {
        data.id = review.id;
        this.action_type = "Update";
        this.$store
          .dispatch("reviewList/UPDATE_GOOGLE_REVIEW", data)
          .then(() => {
            this.$vs.notify({
              title: "Success",
              text: "Update review success",
              color: "success",
              position: "top-right"
            });
            this.closeLoading(index);
          });
      } else {
        this.action_type = "Add";
        this.$store
          .dispatch("reviewList/CREATE_GOOGLE_REVIEW", data)
          .then(() => {
            this.$vs.notify({
              title: "Notification",
              text: "Add Review Success",
              color: "success",
              position: "top-right"
            });
            this.closeLoading(index);
          });
      }
    },
    addGoodReview() {
      this.abc++;
      let checkEmptyLines = this.reviews.good_review.content.filter(review => {
        return review.content === "" || review.status === 3;
      });
      if (checkEmptyLines.length == 0) {
        return this.reviews.good_review.addNewReview();
      }
    },
    addBadReview() {
      let checkEmptyLines = this.reviews.bad_review.content.filter(review => {
        return review.content === "" || review.status === 3;
      });
      if (checkEmptyLines.length == 0) {
        return this.reviews.bad_review.addNewReview();
      }
    },
    changeGoodReview(event, index) {
      this.reviews.good_review.content[index].updateContent(event.target.value);
      //0: deleted, 1: not update, 2: updated, 3: new added
      if (
        this.reviews.good_review.content[index].status == 1 ||
        this.reviews.good_review.content[index].status == 2
      ) {
        this.reviews.good_review.content[index].changeStatus(2);
      }

      this.setAutoHeight(`google-good-review-${index}`);
    },
    changeBadReview(event, index) {
      this.reviews.bad_review.content[index].updateContent(event.target.value);
      //0: deleted, 1: not update, 2: updated, 3: new added
      if (
        this.reviews.bad_review.content[index].status == 1 ||
        this.reviews.bad_review.content[index].status == 2
      ) {
        this.reviews.bad_review.content[index].changeStatus(2);
      }

      this.setAutoHeight(`google-bad-review-${index}`);
    },
    startRemoveGoodReview(review, index) {
      if (review.status == 3) {
        this.reviews.good_review.removeReview(index);
      } else {
        this.popupGoodActive = true;
      }
    },
    startRemoveBadReview(review, index) {
      if (review.status == 3) {
        this.reviews.bad_review.removeReview(index);
      } else {
        this.popupBadActive = true;
      }
    },
    removeReview() {
      let data = {
        id: this.activeReview.id
      };
      this.action_type = 'Delete';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("reviewList/DELETE_GOOGLE_REVIEW", data).then(() => {
        this.popupGoodActive = false;
        this.popupBadActive = false;
        this.closeLoading();
      });
    },
    removeGoodReview(index) {
      this.reviews.good_review.content[index].changeStatus(0);
    },
    removeBadReview(index) {
      this.reviews.bad_review.content[index].changeStatus(0);
    },
    setAutoHeight(id) {
      let elem = document.getElementById(id);
      if (elem) {
        elem.style.height = "auto";
        elem.style.maxHeight = 43 + 'px';
        if(elem.scrollHeight > 43) {
          elem.style.maxHeight = 'unset';
        }
        elem.style.height = elem.scrollHeight + 2 + "px";
      }
    },
    setAutoHeightAllElem() {
      setTimeout(() => {
        if(this.reviews) {
          if(this.reviews.good_review && this.reviews.good_review.content) {
            for(let i = 0; i < this.reviews.good_review.content.length; i++) {
                this.setAutoHeight(`google-good-review-${i}`);
            }
          }

          if(this.reviews.bad_review && this.reviews.bad_review.content) {
            for(let i = 0; i < this.reviews.bad_review.content.length; i++) {
                this.setAutoHeight(`google-bad-review-${i}`);
            }
          }
        }
      }, 100);
    }
  },
  computed: {
    googleReview() {
      return this.$store.getters["reviewList/googleReview"];
    }
  },
  watch: {
    //   dataChange: {
    //     immediate: true,
    //     deep: true,
    //     handler: function () {
    //     //   if(this.dataChange) {
    //     //     console.log(this.dataChange.message);
    //     //   }
    //       // if(this.dataChange && this.dataChange.message == 'afterInsert') {
    //       if(this.dataChange) {
    //         this.$store.dispatch('reviewList/GET_GOOGLE_REVIEW');
    //       }
    //     },
    //   },
    googleReview: {
      immediate: true,
      deep: true,
      handler() {
        this.reviews = this.$store.getters["reviewList/googleReview"];
      }
    },
    loaded_data_num: {
      immediate: true,
      handler() {
          if(this.loaded_data_num >= 1) {
              this.closeLoading();
          } else {
              this.action_type = "Get data";
              this.openLoadingInDiv();
          }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
        window.addEventListener("resize", this.setAutoHeightAllElem);
    });
  },
  created() {
    const obj = {
      key: 'config.google_auto_reply.reply_from'
    }
    this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
      let replyFrom = {}
      replyFrom = this.$store.getters["appSetting/keyStorage"];
      this.replyFromDate = replyFrom.value;
      this.loaded_data_num++;
    }).catch(() => {
      const obj = {
        key: 'config.google_auto_reply.reply_from',
        value: moment(new Date()).format('YYYY/MM/DD')
      }
      this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
        this.loaded_data_num++;
      })
    })
  }
};
</script>